import React, { FunctionComponent } from "react"
import templateManagementTableItems from "./TemplateManagementTableItems"
import "./TemplateManagementTable.css"

const TemplateManagementTableHeader: FunctionComponent<{}> = () => {

    return (
        <thead>
            <tr id="c6c7a79ba4c4587910f81ebf5b37b92">
                {templateManagementTableItems.map((item, i) =>
                    <th 
                    style={{maxWidth: item.maxWidth}}
                    key={i}
                    >
                        {item.title}
                    </th>
                )}
            </tr>
        </thead>
    )
}

export default TemplateManagementTableHeader